import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import minMax from 'dayjs/plugin/minMax';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(minMax);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(updateLocale);
dayjs.extend(localeData);
dayjs.extend(isBetween);
dayjs.extend(calendar);

export const DATE_FORMATS = {
  YYYYMMDD: 'YYYY/MM/DD',
  USA_FORMAT: 'YYYY-MM-DD',
  BR_FORMAT: 'DD/MM/YYYY',
  BR_FORMAT_DASHED: 'DD-MM-YYYY',
  PDF_FORMAT: 'MMMM D, YYYY',
  YYYYMMMDD: 'YYYY MMM DD',
  MMMDYYYY: 'MMM D, YYYY',
  hmmA: 'h:mm A',
  MMMD: 'MMM D',
  MMMDoYYY: 'MMM Do, YYYY',
  DDMMMYYYY: 'DD MMM, YYYY',
  DDMMM: 'DD MMM',
  MMMMDD: 'MMMM DD',
  DDMMMYYYY_SPACED: 'DD MMM YYYY',
  MMMDDYYYY_COMMA: 'MMM DD, YYYY',
  MMMDD: 'MMM DD',
  LL: 'll',
  L: 'l',
};

export const isSameOrAfter = (initialDate: Dayjs, targetDate: Dayjs): boolean =>
  targetDate.isSame(initialDate) || targetDate.isAfter(initialDate);

export const isSameOrBefore = (finalDate: Dayjs, targetDate: Dayjs): boolean =>
  targetDate.isSame(finalDate) || targetDate.isBefore(finalDate);

dayjs.updateLocale('pt-br', {
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
    LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
  },
});

export default dayjs;
